import { LineCol } from "../gen/SrcLoc";

export interface StatusbarProps {
  cursorPosition: LineCol;
}

export function mkStatusbarProps(): StatusbarProps {
  return {
    cursorPosition: {
      line: 1,
      col: 1
    }
  };
}

function Statusbar(props: StatusbarProps): JSX.Element {
  return (
    <div>
      Line: {props.cursorPosition.line} Column: {props.cursorPosition.col}
    </div>
  );
}

export default Statusbar;
